import CurrentOffers from "./CurrentOffers";

export default CurrentOffers;
